import { isEmptyString } from '@/utils/string';

/** The name services gives every new Agent chat when it creates the session. */
const DEFAULT_SESSION_NAME = 'New Conversation';

/** True until the chat has a real name, from auto-naming or from the user. */
export function isUnnamedSession(name: string | null | undefined): boolean {
  return isEmptyString(name) || name.trim() === DEFAULT_SESSION_NAME;
}
